import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { toast } from "react-toastify";
import { putApi, deleteApi } from "../../../Services/apiService";
import { getFamilyTreeIdFromStorage } from "../../../Utils/headOfLineRole";

const DeleteEventModal = ({ isOpen, onClose, eventId, onDeleted, mode = "delete", isArchivedDelete = false }) => {
  const [loading, setLoading] = useState(false);

  // Reset loading when modal closes/opens
  useEffect(() => {
    if (!isOpen) {
      setLoading(false);
    }
  }, [isOpen]);

  // Handle event deletion
  // When isArchivedDelete (archived section card delete): use same API as "delete selected ones" (delete-events).
  // Otherwise (cancel/delete non-archived): use cancel-event API.
  const deleteEvent = async () => {
    setLoading(true);

    try {
      if (isArchivedDelete && mode === "delete") {
        const response = await deleteApi("/delete-events", {
          data: { event_ids: [eventId] },
        });
        if (response?.statusCode === 200) {
          toast.success(response?.message || "Event deleted successfully");
          onClose();
          if (typeof onDeleted === "function") {
            onDeleted();
          }
        }
      } else {
        const family_tree_id = getFamilyTreeIdFromStorage();

        const response = await putApi(
          `/cancel-event/${eventId}?family_tree_id=${family_tree_id}`,
          { reason: "" }
        );

        if (response?.statusCode === 200) {
          toast.success(response?.message || "Event cancelled successfully");
          onClose();
          if (typeof onDeleted === "function") {
            onDeleted();
          }
        }
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.message || (isArchivedDelete && mode === "delete" ? "Issue while deleting the event" : "Issue while cancelling the event"));
    } finally {
      setLoading(false);
    }
  };

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      border: 'none',
      background: 'transparent',
      padding: '0',
      maxWidth: '420px',
      width: '100%'
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 1000
    }
  };

  const isCancelMode = mode === "cancel";
  const titleText = isCancelMode ? "Cancel Event" : "Delete Event";
  const bodyText = isCancelMode
    ? "Are you sure you want to cancel this event?"
    : "Are you sure you want to delete this event?";
  const primaryIdleText = isCancelMode ? "Yes, Cancel Event" : "Yes, Delete Event";
  const primaryLoadingText = isCancelMode ? "Cancelling..." : "Deleting...";

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={customStyles}
      portalClassName="logOut"
      contentLabel="Delete Event Confirmation"
      ariaHideApp={false}
    >
      <div className="modal-content">
        <div className="modal-header">
          <div>
            <span>
              <img src={window.getPublicUrl('/assets/images/logout.svg')} alt=''/>
            </span>
            <button
              type="button"
              className="close"
              onClick={onClose}
              aria-label="Close"
              disabled={loading}
            >
              <img src={window.getPublicUrl('/assets/images/close.svg')} alt=''/>
            </button>
          </div>
        </div>
        <div className="modal-body">
          <h5 className="modal-body-hading">{titleText}</h5>
          <p className="modal-peragrapgh">{bodyText}</p>
        </div>
        <div
          className="modal-footer"
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '12px',
          }}
        >
          <button
            type="button"
            className="btn btn-cancel"
            onClick={onClose}
            disabled={loading}
            style={{ width: '170px', height: '48px' }}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-block"
            onClick={deleteEvent}
            disabled={loading}
            style={{ width: '170px', height: '48px' }}
            >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                {primaryLoadingText}
              </>
            ) : (
              primaryIdleText
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteEventModal;
